function l(n, t) {
  return !n || n.height <= 0 ? [] : [{ left: 0, right: t, bottom: n.y + n.height + 8 }];
}
function a(n, t, r, i) {
  let e = t;
  for (const o of i)
    n < o.right && n + r > o.left && t < o.bottom && (e = Math.max(e, o.bottom));
  return e;
}
function f() {
  if (typeof navigator > "u") return null;
  const n = navigator.windowControlsOverlay;
  if (!n?.visible) return null;
  const t = n.getTitlebarAreaRect();
  return { x: t.x, y: t.y, width: t.width, height: t.height };
}
function u() {
  return typeof window > "u" ? [] : l(f(), window.innerWidth);
}
function d(n = u) {
  return {
    name: "windowControlsClearance",
    fn({ x: t, y: r, rects: i }) {
      const e = n();
      if (e.length === 0) return {};
      const o = a(t, r, i.floating.width, e);
      return o === r ? {} : { y: o, data: { pushed: o - r } };
    }
  };
}
export {
  d as w
};
//# sourceMappingURL=windowControlsClearance-BonpJzP6.js.map
